// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_container__sSzjW {
  width: 100%;
  overflow-x: hidden;
}
.table_container__sSzjW table {
  width: 100%;
  overflow-x: auto !important;
  display: block;
}
.table_container__sSzjW table thead {
  display: block;
}
.table_container__sSzjW table thead tr {
  min-width: 900px;
  height: 40px;
  padding-left: 20px;
  background: white;
  border: 1px solid #E9E8EB;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table_container__sSzjW table th {
  font-family: "Inter";
  font-style: normal;
  text-align: left;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #0d0f0f;
  display: block;
}
.table_container__sSzjW table tbody {
  display: block;
}
.table_container__sSzjW table tbody tr {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E9E8EB;
  border-left: 1px solid #E9E8EB;
  border-right: 1px solid #E9E8EB;
}
.table_container__sSzjW table td {
  display: flex;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #131213;
  width: 100%;
  text-align: left;
  height: 58px;
  align-items: center;
  text-transform: capitalize;
  background: white;
  padding: 0 8px;
  box-sizing: border-box;
  border: none;
}
.table_container__sSzjW table .table_table-container__eSzka {
  border-left: 1px solid #E9E8EB;
  border-right: 1px solid #E9E8EB;
  overflow: hidden;
}
.table_container__sSzjW .table_tablesearch__jC436 {
  height: 52px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E9E8EB;
  display: flex;
}
@media screen and (max-width: 600px) {
  .table_container__sSzjW .table_tablesearch__jC436 {
    padding: 0 10px;
  }
}
.table_container__sSzjW .table_tablesearch__jC436 .table_searchicon__oJxms,
.table_container__sSzjW .table_tablesearch__jC436 .table_sorticon__SEqTR {
  width: 5%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.table_container__sSzjW .table_tablesearch__jC436 input {
  width: 90%;
  padding: 10px;
  outline: none;
}
.table_container__sSzjW .table_pagination__Vx7d0 {
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  background: #FFFFFF;
  border: 1px solid #E9E8EB;
  border-radius: 4px;
  flex: none;
  order: 7;
  align-self: center;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
@media screen and (max-width: 600px) {
  .table_container__sSzjW .table_pagination__Vx7d0 .table_rowPerpage__YXlGd {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/table/table.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;AACJ;AACI;EACI,WAAA;EACA,2BAAA;EACA,cAAA;AACR;AACQ;EACI,cAAA;AACZ;AACY;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAChB;AAGQ;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AADZ;AAIQ;EACI,cAAA;AAFZ;AAIY;EACI,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;AAFhB;AAMQ;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EAEA,YAAA;AALZ;AAQQ;EACI,8BAAA;EACA,+BAAA;EACA,gBAAA;AANZ;AAUI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AARR;AAUQ;EAPJ;IAQQ,eAAA;EAPV;AACF;AASQ;;EAEI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,UAAA;EACA,aAAA;EACA,aAAA;AARZ;AAYI;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAVR;AAaY;EADJ;IAEQ,aAAA;EAVd;AACF","sourcesContent":[".container {\n    width: 100%;\n    overflow-x: hidden;\n\n    table {\n        width: 100%;\n        overflow-x: auto !important;\n        display: block;\n\n        thead {\n            display: block;\n\n            tr {\n                min-width: 900px;\n                height: 40px;\n                padding-left: 20px;\n                background: white;\n                border: 1px solid #E9E8EB; \n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n            }\n        }\n\n        th {\n            font-family: 'Inter';\n            font-style: normal;\n            text-align: left;\n            width: 100%;\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 150%;\n            letter-spacing: 0.25px;\n            color: #0d0f0f;\n            display: block;\n        }\n\n        tbody {\n            display: block;\n            \n            tr {\n                display: flex;\n                justify-content: space-between;\n                border-bottom: 1px solid #E9E8EB; \n                border-left: 1px solid #E9E8EB; \n                border-right: 1px solid #E9E8EB; \n            }\n        }\n\n        td {\n            display: flex;\n            font-family: 'Inter';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 150%;\n            letter-spacing: 0.25px;\n            color: #131213;\n            width: 100%;\n            text-align: left;\n            height: 58px;\n            align-items: center;\n            text-transform: capitalize;\n            background: white;\n            padding: 0 8px;\n            box-sizing: border-box;\n            \n            border: none; \n        }\n\n        .table-container {\n            border-left: 1px solid #E9E8EB;\n            border-right: 1px solid #E9E8EB;\n            overflow: hidden;\n        }\n    }\n\n    .tablesearch {\n        height: 52px;\n        width: 100%;\n        background: #FFFFFF;\n        border: 1px solid #E9E8EB;\n        display: flex;\n\n        @media screen and (max-width: 600px) {\n            padding: 0 10px;\n        }\n\n        .searchicon,\n        .sorticon {\n            width: 5%;\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n        }\n\n        input {\n            width: 90%;\n            padding: 10px;\n            outline: none;\n        }\n    }\n\n    .pagination {\n        box-sizing: border-box;\n        width: 100%;\n        height: 50px;\n        background: #FFFFFF;\n        border: 1px solid #E9E8EB;\n        border-radius: 4px;\n        flex: none;\n        order: 7;\n        align-self: center;\n        flex-grow: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n\n        .rowPerpage {\n            @media screen and (max-width: 600px) {\n                display: none; \n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table_container__sSzjW`,
	"table-container": `table_table-container__eSzka`,
	"tablesearch": `table_tablesearch__jC436`,
	"searchicon": `table_searchicon__oJxms`,
	"sorticon": `table_sorticon__SEqTR`,
	"pagination": `table_pagination__Vx7d0`,
	"rowPerpage": `table_rowPerpage__YXlGd`
};
export default ___CSS_LOADER_EXPORT___;
